import React from 'react';
import { Link } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import { showErrorToast } from '../../actions/toast';

export default ({ to, className, children, onClick, id, disabled }) => {
  const { isOffline } = useSelector(state => state.appStatus);
  const dispatch = useDispatch();
  const preventClick = event => {
    if (disabled) {
      return event.preventDefault();
    }
    if (isOffline) {
      dispatch(
        showErrorToast(
          'Action cannot be completed. Please check your internet connection.'
        )
      );
      return event.preventDefault();
    }
    if (onClick) {
      onClick();
    }
    return '';
  };
  return (
    <Link
      id={id}
      onClick={preventClick}
      to={to}
      className={className}
      aria-disabled={disabled}
      tabIndex={disabled ? -1 : undefined}
      style={disabled ? { pointerEvents: 'none', opacity: 0.5 } : undefined}
    >
      {children}
    </Link>
  );
};
